// extracted by mini-css-extract-plugin
export var orderSummary = "_u8-0";
export var showMoreLessButton = "_u8-1";